<template>
  <div class="app-process-confirm-modal">
    <b-modal :id="'processConfirmModal' + _uid"
             size="xl"
             data-qa="modal"
             :modal-class="'app-process-confirm-modal ' + processClass"
             :title="modalTitle"
             v-model="show_"
             @hidden="$emit('hidden', $event)"
             :hide-footer="modalHideFooter"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
             footer-bg-variant="custom"
             footer-text-variant="custom"
             ok-only ok-title="Schließen"
    >
      <div slot="modal-title">
        <slot name="txtModalTitle"></slot>
      </div>
      <dyn-slot :slot-data="slotData">
        <slot name="txtModalBody"></slot>
      </dyn-slot>
      <div slot="modal-footer" v-if="showStepper">
        <Stepper
          @prev="$emit('back')"
          @next="$emit('next')"
          :loading-next="loading"
          :show-prev="showPrev"
          :disabled-next="disabledNext"
        >
          <template #btnPrev><slot name="btnPrev"></slot></template>
          <template #btnNext><slot name="btnNext"></slot></template>
        </Stepper>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import Stepper from '@/components/generic/Stepper'
import syncProperty from '@/mixins/syncProperty'

export const stepName = 'confirmModal'

export default {
  name: 'ProcessConfirmModal',
  mixins: [
    syncProperty('show', 'show_')
  ],
  components: { BModal, Stepper },
  computed: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: ''
    },
    showStepper: {
      type: Boolean,
      default: true
    },
    slotData: {
      type: Object
    },
    modalHideFooter: {
      type: Boolean,
      default: false
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    processClass: {
      type: String,
      default: ''
    },
    disabledNext: {
      type: Boolean,
      default: false
    }
  }
}

</script>
